export default "__VITE_ASSET__DYPWPgyR__"